<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Stock on Hand
        <small>Current inventory levels by category</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">IMS / Reports</a> /
        <span class="current">Stock on Hand</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-outline btn-sm" (click)="printPage()"><i class="bi bi-printer"></i> Print</button>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-box-seam"></i>
        <h2>Stock on Hand</h2>
        <span class="report-badge">{{ dateRange.appliedDayCount() }} days</span>
      </div>
    </div>
    <div class="report-body">
      <div class="report-stats">
        <div class="stat-item">
          <span class="stat-label">Total Items</span>
          <span class="stat-value">{{ summary().totalItems | number }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Total Value</span>
          <span class="stat-value">{{ formatCurrency(summary().totalValue) }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Categories</span>
          <span class="stat-value">{{ summary().categories }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">Locations</span>
          <span class="stat-value">{{ summary().locations }}</span>
        </div>
      </div>
      <div class="report-chart">
        <div class="mini-bar-chart">
          @for (cat of categories(); track cat.category) {
            <div class="mini-bar-group">
              <div class="mini-bar" [style.height.px]="barHeight(cat.value)"></div>
              <span>{{ cat.category }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
